import _ from 'lodash';
import endpoints from '../endpoints';
import StoreFromFile from './StoreFromFile';

// Material numbers of products that should not be shown in the app
const HIDDEN_MATERIAL_NUMBERS = ['10028-00-00123', '10029-00-00123'];

const isHidden = (product) => _.isObject(product)
  && [].concat(product.mat).some((mat) => HIDDEN_MATERIAL_NUMBERS.includes(mat));

const removeHiddenProducts = (doc) => _.mapValues(doc, (productsByNumber) => {
  if (!_.isPlainObject(productsByNumber)) return productsByNumber;
  return _.omitBy(productsByNumber, isHidden);
});

class ProductsStore extends StoreFromFile {
  constructor(name) {
    super(name);
    this.storeSavedName = 'XXSProducts';
    this.endpoint = endpoints.products.get;

    const loadAll = this.load;
    this.load = (callback) => loadAll((doc) => callback(doc && removeHiddenProducts(doc)));
  }
}

export default ProductsStore;
